import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

const Checkpoint = ({
  children,
  iconClassNames,
  className,
  contentClassName
}) => {
  return (
    <div className={classnames(styles.container, className)}>
      <div className={classnames(styles.checkIcon, iconClassNames)}>
        <i className={classnames('material-icons', styles.materialIcon)}>
          check
        </i>
      </div>
      <div className={classnames(styles.content, contentClassName)}>
        {children}
      </div>
    </div>
  );
};

export default Checkpoint;
